import Positions from '../../../../../store/billing/positions';

class BillingSelectPositionController {
    constructor($injector, Position, $uibModalInstance, $scope) {
        this.positionModel = Position;
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;

        this.dataToReturn = null;
        const store = new Positions(this.positionModel, {injector: $injector});
        this.selectConfig = {
            store: store.reset({
                persist: false,
                listview: 'SelectPositionListView'
            }),
            maxItems: 1,
            displayField: 'title'
        };

        this.loadingFullPosition = false;
        this.selectedPosition = null;
        this.fullPosition = null;

        this.scope.$watch(() => {
            return this.selectedPosition;
        }, () => {
           this.onSelectionChange();
        });
    }

    onSelectionChange() {
        this.loadingFullPosition = true;
        if (this.selectedPosition) {
            this.positionModel.one(this.selectedPosition).get().then((response) => {
                console.log(response.plain())
                this.fullPosition = response.plain();
                this.loadingFullPosition = false;
            }, () => {
                this.fullPosition = null;
                this.loadingFullPosition = false;
            });
        } else {
            this.fullPosition = null;
            this.loadingFullPosition = false;
        }
    }

    submit() {
        this.close(this.fullPosition);
    }

    close(data) {
        this.modalInstance.close(data);
    }

    cancel() {
        this.modalInstance.dismiss();
    }
}

BillingSelectPositionController.$inject = [
    '$injector',
    'Position',
    '$uibModalInstance',
    '$scope'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:BillingSelectPositionController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('BillingSelectPositionController', BillingSelectPositionController);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/modals/select-position-controller.js